import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function convertToNumberWithCommas(num: string | number): string {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function generateArrayOfYears() {
  const max = new Date().getFullYear();
  const min = 2023;
  const years: number[] = [];

  // eslint-disable-next-line no-plusplus
  for (let i = max; i >= min; i--) {
    years.push(i);
  }
  return years.reverse();
}

export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export const formatSize = (size: number) => {
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];

  let i = 0;
  while (size >= 1024 && i < units.length - 1) {
    // eslint-disable-next-line no-param-reassign
    size /= 1024;
    i += 1;
  }

  return `${size.toFixed(1)} ${units[i]}`;
};

export const validateEmail = (email: string) => {
  const re = /\S+@\S+\.\S+/;
  return re.test(email);
};
